// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mmwb","label":"styles_label__1FJB6"};